/**
 * This file is a copy/paste of what we need from the
 * prosemirror-example-setup package. We can't import this package
 * because it doesn't export what we need anymore. If the code below
 * isn't good enough for your needs, we should probably start by
 * refactoring it to something reasonable.
 */

/**
The type of field that `openPrompt` expects to be passed to it.
 */
class Field {
	/**
    Create a field with the given options. Options support by all
    field types are:
	 */
	constructor(options) {
		this.options = options;
	}

	/**
    Read the field's value from its DOM node.
	 */
	read(dom) {
		return dom.value;
	}

	/**
    A field-type-specific validation function.
	 */
	// eslint-disable-next-line no-unused-vars -- Copy/pasted from prosemirror-example-setup
	validateType(value) {
		return null;
	}

	validate(value) {
		if (!value && this.options.required) return "Required field";
		return (
			this.validateType(value) ||
			(this.options.validate ? this.options.validate(value) : null)
		);
	}

	clean(value) {
		return this.options.clean ? this.options.clean(value) : value;
	}
}

/**
A field class for single-line text fields.
 */
export class TextField extends Field {
	render() {
		const input = document.createElement("input");
		input.type = "text";
		input.placeholder = this.options.label;
		input.value = this.options.value || "";
		input.autocomplete = "off";
		return input;
	}
}

const prefix = "ProseMirror-prompt";

function getValues(fields, domFields) {
	const result = Object.create(null);
	let i = 0;
	for (const name in fields) {
		const field = fields[name];
		const dom = domFields[i++];
		const value = field.read(dom);
		const bad = field.validate(value);
		if (bad) {
			reportInvalid(dom, bad);
			return null;
		}
		result[name] = field.clean(value);
	}
	return result;
}

function reportInvalid(dom, message) {
	const parent = dom.parentNode;
	const msg = parent.appendChild(document.createElement("div"));
	msg.style.left = `${dom.offsetLeft + dom.offsetWidth + 2}px`;
	msg.style.top = `${dom.offsetTop - 5}px`;
	msg.className = "ProseMirror-invalid";
	msg.textContent = message;
	setTimeout(() => parent.removeChild(msg), 1500);
}

/**
 * Todo: Add JSDoc comment
 */
export function openPrompt(options) {
	const wrapper = document.body.appendChild(document.createElement("div"));
	wrapper.className = prefix;
	// eslint-disable-next-line @shopify/prefer-early-return -- Copy/pasted from prosemirror-example-setup
	const mouseOutside = (e) => {
		// eslint-disable-next-line no-use-before-define -- Copy/pasted from prosemirror-example-setup
		if (!wrapper.contains(e.target)) close();
	};
	setTimeout(() => window.addEventListener("mousedown", mouseOutside), 50);
	const close = () => {
		window.removeEventListener("mousedown", mouseOutside);
		if (wrapper.parentNode) wrapper.parentNode.removeChild(wrapper);
	};
	const domFields = [];
	for (const name in options.fields)
		domFields.push(options.fields[name].render());
	const submitButton = document.createElement("button");
	submitButton.type = "submit";
	submitButton.className = `${prefix}-submit`;
	submitButton.textContent = "OK";
	const cancelButton = document.createElement("button");
	cancelButton.type = "button";
	cancelButton.className = `${prefix}-cancel`;
	cancelButton.textContent = "Cancel";
	cancelButton.addEventListener("click", close);
	const form = wrapper.appendChild(document.createElement("form"));
	if (options.title)
		form.appendChild(document.createElement("h5")).textContent =
			options.title;

	domFields.forEach((field) => {
		form.appendChild(document.createElement("div")).appendChild(field);
	});

	const buttons = form.appendChild(document.createElement("div"));
	buttons.className = `${prefix}-buttons`;
	buttons.appendChild(submitButton);
	buttons.appendChild(document.createTextNode(" "));
	buttons.appendChild(cancelButton);
	const box = wrapper.getBoundingClientRect();
	wrapper.style.top = `${(window.innerHeight - box.height) / 2}px`;
	wrapper.style.left = `${(window.innerWidth - box.width) / 2}px`;
	const submit = () => {
		const params = getValues(options.fields, domFields);
		if (params) {
			close();
			options.callback(params);
		}
	};

	form.addEventListener("submit", (e) => {
		e.preventDefault();
		submit();
	});

	form.addEventListener("keydown", (e) => {
		// eslint-disable-next-line eqeqeq -- Copy/pasted from prosemirror-example-setup
		if (e.keyCode == 27) {
			e.preventDefault();
			close();
			// eslint-disable-next-line eqeqeq -- Copy/pasted from prosemirror-example-setup
		} else if (e.keyCode == 13 && !(e.ctrlKey || e.metaKey || e.shiftKey)) {
			e.preventDefault();
			submit();
			// eslint-disable-next-line eqeqeq -- Copy/pasted from prosemirror-example-setup
		} else if (e.keyCode == 9) {
			// eslint-disable-next-line @shopify/prefer-early-return -- Copy/pasted from prosemirror-example-setup
			window.setTimeout(() => {
				if (!wrapper.contains(document.activeElement)) close();
			}, 500);
		}
	});

	const input = form.elements[0];
	if (input) input.focus();
}
